import {Box, Text} from '@mantine/core';
import {useRouter} from 'next/router';
import {parseCookies} from 'nookies';
import type {FC} from 'react';
import {useState} from 'react';
import {MdClose, MdWarning} from 'react-icons/md';
import {PROFILE_BASE} from '../../config/constants/routes';
import {isReleasedNewRegisterFlow} from '../../config/unReleasePage';
import {useUsersMe} from '../../core/repositories/usersMeRepository';
import {validateCookie} from '../../core/usecases/auth/checkOauthTokenExistence';
import {cn} from '../../lib/classname';
import {useMediaQuery} from '../services/useMediaQuery';
import {CommonLink} from './CommonLink';

const BUTTON_TEXT = '認証する';

export const EmailConfirmNotice: FC = () => {
  const router = useRouter();
  const cookies = parseCookies();
  const {isValid} = validateCookie(cookies);

  const isNewRegisterFlow = isReleasedNewRegisterFlow();
  const {isPC} = useMediaQuery();
  const [isHidden, setIsHidden] = useState(false);

  const MESSAGE_TEXT = `${isNewRegisterFlow ? '' : 'いつも使う'}メールアドレスが認証されていません。`;

  const {data: usersMe} = useUsersMe({
    config: {enabled: isValid},
  });

  // 特定のページでは表示しない
  const hiddenPaths = [PROFILE_BASE];
  const shouldHideOnCurrentPath = hiddenPaths.includes(router.pathname);

  if (
    !usersMe?.ok ||
    usersMe.value.isEmailConfirmed ||
    isHidden ||
    shouldHideOnCurrentPath
  ) {
    return null;
  }

  const CloseButton = () => (
    <Box
      className={cn(
        'flex items-center justify-center cursor-pointer',
        isPC ? 'w-24 h-24 rounded-full bg-black-3' : 'text-primary-1',
      )}
      onClick={() => {
        setIsHidden(true);
      }}
    >
      <MdClose
        size={isPC ? 24 : 16}
        color={isPC ? 'white' : undefined}
        className={cn(!isPC && 'text-black-3')}
      />
    </Box>
  );

  const AuthLink = () => (
    <CommonLink
      href={PROFILE_BASE}
      className={cn(
        'cursor-pointer flex items-center justify-center border-notification border-[1px] bg-white rounded-[8px] py-8 px-12 text-xs pc:text-sm text-notification font-bold whitespace-nowrap',
      )}
    >
      {BUTTON_TEXT}
    </CommonLink>
  );

  return (
    <div className="pc:bg-background-1 pc:pt-20 pc:my-0 mt-12 pc:mx-0 mx-16">
      <div className="bg-white mx-auto pc:my-0 pc:max-w-[1200px] py-12 px-16 relative overflow-hidden items-center rounded-[8px] shadow-card">
        {isPC ? (
          <Box className="flex flex-row justify-between items-center">
            <Box className="flex flex-row items-center text-base text-black">
              <MdWarning size={24} className="text-notification-1 mr-8" />
              <Text className="mr-8">{MESSAGE_TEXT}</Text>
            </Box>
            <Box className="flex flex-row items-center gap-12">
              <AuthLink />
              <CloseButton />
            </Box>
          </Box>
        ) : (
          <Box className="flex flex-row items-center justify-between text-xs gap-8">
            <MdWarning size={20} className="text-notification-1" />
            <Text className="mr-2">{MESSAGE_TEXT}</Text>
            <AuthLink />
            <CloseButton />
          </Box>
        )}
      </div>
    </div>
  );
};
